<template>
    <div>
        <!-- Pagination -->
        <ul class="pagination justify-content-center flex-wrap" v-if="numOfPages > 1">
            <li class="page-item">
                <router-link :to="{ name: routePath, params: { page: 1 } }" exact title="erste Seite" class="page-link arrow-first-last">
                    <span aria-hidden="true">&laquo;</span>
                </router-link>
            </li>
            <template v-if="numOfPages <= maxNumberPages">
                <li class="page-item" v-for="num in numOfPages" :key="num">
                    <router-link :to="{ name: routePath, params: { page: num } }" exact class="page-link" >{{num}}</router-link>
                </li>
            </template>
            <template v-else>
                <li class="page-item" v-if="page > 1">
                    <router-link :to="{ name: routePath, params: { page: page - 1 } }" exact class="page-link" >&lsaquo;</router-link>
                </li>
                <template v-if="getMaxNumberPages() < maxNumberPages">
                    <li class="page-item" v-for="num in decendingNumber()" :key="page - num">
                        <router-link :to="{ name: routePath, params: { page: page - num } }" exact class="page-link" >{{page - num}}</router-link>
                    </li>
                </template>
                <li class="page-item" v-for="(num, index) in getMaxNumberPages()" :key="getPageNumber(index)">
                    <router-link :to="{ name: routePath, params: { page: getPageNumber(index) } }" exact class="page-link" >{{getPageNumber(index)}}</router-link>
                </li>
                <li class="page-item" v-if="numOfPages >= getPageNumber(maxNumberPages)">
                    <router-link :to="{ name: routePath, params: { page: getPageNumber(1) } }" exact class="page-link" >&rsaquo;</router-link>
                </li>
            </template>
            <li class="page-item">
                <router-link :to="{ name: routePath, params: { page: numOfPages } }" title="letzte Seite" class="page-link arrow-first-last">
                    <span aria-hidden="true">&raquo;</span>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                maxNumberPages: 5
            }
        },
        props: [
            'page',
            'numOfPages',
            'routePath',
        ],
        methods: {
            scrollTop() {
                window.scrollTo(0, 0);
            },
            getMaxNumberPages() {
                let restPages = this.numOfPages - this.page + 1;
                return restPages > this.maxNumberPages ? this.maxNumberPages : restPages;
            },
            getPageNumber(index){
                return this.page * 1 + index;
            },
            decendingNumber() {
                let max    = this.maxNumberPages - this.getMaxNumberPages();
                let number = [];
                for(let i = max; i > 0; i--){
                    number.push(i);
                }
                return number;
            },
        },
        mounted() {
          this.scrollTop();
        }
    }
</script>

<style scoped>
.page-link{
    color: #5FA963 !important;
    font-weight: 600;
}
.router-link-exact-active.router-link-active{
    background-color: rgb(206, 228, 207);
}
.arrow-first-last{
    background-color: #fff !important;
}
</style>
